/*global SvtPlayAndroid */
'use strict';
import ErrorType from '../constants/error-type';

var Sizzle = require('sizzle');
var External = require('../util/external');
var device = require('../util/device');
var VideoConfig = require('../config');
var VideoDataBuilder = require('../util/video-data-builder');

var Debug = require('../util/debug')('android-native');
module.exports = {
	create: function (api) {

		if (!device.isAndroidApp()) {
			return;
		}

		var videoData,
			_positions = {};

		function _sendEvent(eventType, data) {
			Debug('Send event: ' + eventType, data);
			api.fire(eventType, data);
		}

		var androidController = {
			_uid: null,
			_videoSettings: null,

			/* Public Methods */
			load: function (videoId) {
				this._uid = Math.round(Math.random() * 1000000) + '';
				Debug('This.uid: ' + this._uid);
				this._addAndroidListener('ended', this._videoCallback);
				this._addAndroidListener('error', this._videoCallback);
				this._addAndroidListener('denied', this._videoCallback);
				this._addAndroidListener('closed', this._videoCallback);
				this._addAndroidListener('onlyAvailableInSweden', this._videoCallback);

				VideoConfig.metadataFetchFunction(videoId, (metadata) => {
					api.fire('metadata', metadata);
					if (api.data().inSweden !== undefined && !api.data().inSweden && (metadata.rights && metadata.rights.geoBlockedSweden)) {
						api.fire('error', {
							name: ErrorType.GEO_BLOCK_ERROR
						});

						return;
					}

					const videoElement = Sizzle('video', api.element())[0];

					api.data()._video = videoElement;

					videoData = VideoDataBuilder.build(videoId, metadata, api);
					_positions[videoId] = Number(videoElement.getAttribute('data-video-startposition')) || 0;
					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});
					api.state().loading = false;
					api.state().ready = true;

					if (api.config.autoplay) {
						api.play();
					}
				},
				(error, data) => {
					if (data) {
						api.fire('metadata', data);
					}
					api.fire('error', error);
				});

				return true;
			},

			unload: function () {
				this._removeAndroidListener('ended');
				this._removeAndroidListener('error');
				this._removeAndroidListener('denied');
				this._removeAndroidListener('closed');
				this._removeAndroidListener('onlyAvailableInSweden');
			},

			play: function () {
				if (videoData === null) {
					Debug.error('No settings loaded!');

					return false;
				}

				if (SvtPlayAndroid.setVideoData) {
					videoData.UID = this._uid;

					videoData.video.position = _positions[videoData.videoId] || 0;

					var strSettings = JSON.stringify(videoData);
					this._currVideoId = videoData.videoId;
					SvtPlayAndroid.setVideoData(strSettings);

					return true;
				}

				return false;
			},

			/* Private Methods */
			_addAndroidListener: function (eventType, method) {
				External.addExternalListener(this._uid, eventType, this, method);
			},

			_removeAndroidListener: function (eventType) {
				External.removeExternalListener(this._uid, eventType, this);
			},
			/**
			 * handles the callbacks from the android app.
			 * @param a_event   name of the event
			 * @param data      data of the callback, different depending of the event type.
			 */
			_videoCallback: function (a_event, data) {
				Debug('_videoCallback(), a_event = ' + a_event + ', data = ' + data);
				var self = this,
					closedFn = function (inData) {
						_positions[self._currVideoId] = inData ? inData.videoPosition : 0;
						_sendEvent('ready', {
							videoId: videoData.videoId,
							externalUi: true
						});
					};
				switch (a_event) {
					case 'ended':
						SvtPlayAndroid.closeVideoPlayer();
						_sendEvent('ended');
						closedFn(data);
						api.reset();
						break;
					case 'closed':
						closedFn(data);
						break;
					case 'error':
					case 'denied':
					case 'onlyAvailableInSweden':
						_sendEvent('error', {
							detail: a_event
						});
						break;
				}
			}

		};

		// Unload old androidController if any
		if (api.androidController) {
			api.androidController.unload();
		}

		api.filters.push({
			load: function (videoId) {
				androidController.load(videoId);
				api.element().on('click', function () {
					api.play();
				});

				return true;
			},
			play: function () {
				return !!androidController.play();
			},
			pause: function () {
				// no-op
				return true;
			},
			seek: function () {
				// no-op
				return true;
			},
			getDuration: function () {
				return true;
			},
			getCurrentTime: function () {
				return true;
			},
			getVolume: function () {
				return true;
			},
			isMuted: function () {
				return true;
			},
			mute: function () {
				return true;
			},
			showCaptions: function () {
				return true;
			},
			setVolume: function () {
				return true;
			}
		});

		api.androidController = androidController;
	},

	destroy: function (api) {
		var androidController = api.androidController;
		if (androidController) {
			androidController.unload();
		}
		api.androidController = undefined;
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/android-native.js